import { Span } from "@vp/swan";
import React from "react";

interface PriceRendererProps {
  pricingElement?: JSX.Element;
}

const PriceRenderer = (props: PriceRendererProps) => {
  const [hasMounted, setHasMounted] = React.useState(false);
  const isPricingReady = !!(hasMounted && props.pricingElement);

  React.useEffect(() => {
    setHasMounted(true);
  }, []);

  return isPricingReady ? <Span>{props.pricingElement}</Span> : <span>&nbsp;</span>;
};

export default PriceRenderer;
